import { ExtendedComment } from './types';

/**
 * Helper function to find the first selectable option from a list of options
 * @param options - Array of options to search through
 * @returns The first selectable option (type === 'item') or null if none found
 */
export function findFirstSelectableOption(options: any[]): any | null {
  if (!options || options.length === 0) return null;

  for (const item of options) {
    if (item.type === 'item') {
      return item;
    } else if (item.type === 'header' && item.children) {
      // Look for first item in children
      for (const child of item.children) {
        if (child.type === 'item') {
          return child;
        }
      }
    }
  }
  return null;
}

/**
 * Generate a timestamp in ISO string format for consistency
 * @returns ISO string timestamp
 */
export function generateTimestamp(): string {
  return new Date().toISOString();
}

export const hasUnreadMentionsForUser = (
  comment: ExtendedComment,
  loggedInuserEmail?: string
): boolean => {
  if (!loggedInuserEmail) return false;

  const lastReadTime = comment.readByMentionTimestamp
    ? new Date(comment.readByMentionTimestamp).getTime()
    : 0;

  // Check main comment
  const mainCommentTime = new Date(
    comment.editedAt || comment.createdAt
  ).getTime();
  const hasMainMention = comment.commentMentions?.some(
    mention => mention.email === loggedInuserEmail
  );

  if (hasMainMention && mainCommentTime > lastReadTime) {
    return true;
  }

  // Check replies - any reply with mention after lastReadTime is unread
  if (comment.replies) {
    return comment.replies.some(reply => {
      const replyTime = new Date(reply.editedAt || reply.createdAt).getTime();
      const hasReplyMention = reply.commentMentions?.some(
        mention => mention.email === loggedInuserEmail
      );
      return hasReplyMention && replyTime > lastReadTime;
    });
  }

  return false;
};
